import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10697557"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-content p-3" }
const _hoisted_2 = { class: "flex flex-column w-full gap-4" }
const _hoisted_3 = {
  class: "card-grid",
  style: {"grid-auto-columns":"minmax(0, 1fr)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfilLeftBar = _resolveComponent("ProfilLeftBar")!
  const _component_MobileUserProfilePannel = _resolveComponent("MobileUserProfilePannel")!
  const _component_BuildingInformationsPannel = _resolveComponent("BuildingInformationsPannel")!
  const _component_SyndicPromotePannel = _resolveComponent("SyndicPromotePannel")!
  const _component_ShopPromotePannel = _resolveComponent("ShopPromotePannel")!
  const _component_FlexHorizonPromotePannel = _resolveComponent("FlexHorizonPromotePannel")!
  const _component_MaintenancePromotePannel = _resolveComponent("MaintenancePromotePannel")!
  const _component_SupportInfoPannel = _resolveComponent("SupportInfoPannel")!
  const _component_BuildingContentInformationsPannel = _resolveComponent("BuildingContentInformationsPannel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ProfilLeftBar, {
      nbAuths: _ctx.auths?.length,
      nbIts: _ctx.itsInfo?.length,
      nbTags: _ctx.tagsInfo?.length,
      nbGateways: _ctx.gatewaysInfo?.length,
      nbZones: _ctx.zonesInfo?.length,
      mylicence: _ctx.licence
    }, null, 8, ["nbAuths", "nbIts", "nbTags", "nbGateways", "nbZones", "mylicence"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_MobileUserProfilePannel, { class: "gsr-2 gsc-2 no-mobile-hide" }),
          _createVNode(_component_BuildingInformationsPannel, {
            class: "gsr-2 gsc-2",
            mybuilding: _ctx.building
          }, null, 8, ["mybuilding"]),
          _createVNode(_component_SyndicPromotePannel, { class: "gsr-2" }),
          _createVNode(_component_ShopPromotePannel, { id: "promote-pannel-1" }),
          _createVNode(_component_FlexHorizonPromotePannel, { id: "promote-pannel-2" }),
          _createVNode(_component_MaintenancePromotePannel, { class: "gsr-2" }),
          _createVNode(_component_SupportInfoPannel, { class: "gsr-2" })
        ]),
        _createVNode(_component_BuildingContentInformationsPannel, {
          myitsinfo: _ctx.itsInfo,
          mytagsinfo: _ctx.tagsInfo,
          mygatewaysinfo: _ctx.gatewaysInfo,
          itsLoading: _ctx.itsLoading
        }, null, 8, ["myitsinfo", "mytagsinfo", "mygatewaysinfo", "itsLoading"])
      ])
    ])
  ], 64))
}